namespace SorAraBul.Common {

    @Serenity.Decorators.registerEditor()
    export class TcknEditor extends Serenity.StringEditor {

        constructor(input: JQuery) {
            super(input);

            this.addValidationRule(this.uniqueName, () => {

                if (!this.validateTcNo(this.value))
                    return "Geçerli bir T.C. Kimlik numarası giriniz.";

                return null;
            });

            this.element.attr("maxlength", "11");
            // opsiyonel: sadece rakam maskesi

            // sadece rakam girişine izin ver
            this.element.on("keypress", (e) => {
                const charCode = e.which ?? e.keyCode;
                if (charCode < 48 || charCode > 57) {
                    e.preventDefault();
                }
            });

            // kopyala/yapıştır ile gelen harfleri temizle
            this.element.on("input", () => {
                const val = this.element.val() as string;
                const filtered = val.replace(/\D/g, "");
                if (val !== filtered) {
                    this.element.val(filtered);
                }
            });
        }

        check_tcno(a): boolean {
            if (a.substr(0, 1) == 0 || a.length != 11) {
                return false;
            }
            var i = 9, md = '', mc = '', digit, mr = '';
            while (digit = a.charAt(--i)) {
                i % 2 == 0 ? md += digit : mc += digit;
            }
            if (((eval(md.split('').join('+')) * 7) - eval(mc.split('').join('+'))) % 10 != parseInt(a.substr(9, 1), 10)) {
                return false;
            }
            for (var c = 0; c <= 9; c++) {
                mr += a.charAt(c);
            }
            if (eval(mr.split('').join('+')) % 10 != parseInt(a.substr(10, 1), 10)) {
                return false;
            }
            return true;
        }

        //Tc Kimlik Numarası kontrol..
        validateTcNo(tcNo: string): boolean {
            return this.check_tcno(tcNo);
        }
    }
}